import React from "react"
export default function ChartToggleComponent({ type, fontSize,color,onClickFunction,value,setterFunction,selected }) {
	const onClickChartType = (value) => {
		onClickFunction(value)
		// setterFunction(!selected)
	}
	return (
		<>
			<i onClick={()=>onClickChartType(value)} className={`fa fa-${type}-chart`} style={{ fontSize: fontSize, cursor: 'pointer',color:value.type === type ? '#009bff' : '#5c667b' }} />
		</>)
}